import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { toast } from 'react-toastify';
import { authAxiosInstance } from '../../utils/axiosConfig';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import QueryString from 'qs';
import moment from 'moment';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';

const Logs = () => {
    const [logData, setLogData] = useState({});
    const [page, setPage] = useState(1);

    const fetchLogs = async (search = null) => {
        try {
            const query = {
                page,
                search : search
            };
            const string = QueryString.stringify(query);
            const resp = await authAxiosInstance.get(`/log?${string}`);
            console.log('resp', resp?.data?.data?.docs);
            setLogData(resp?.data?.data);
        } catch (error) {
            console.log('Error', error);
            toast.error('Failed to fetch Logs');
        }
    };

    useEffect(() => {
        fetchLogs();
    }, [page]);

    const logMemo = useMemo(() => {
        if (logData?.docs && logData?.docs.length > 0) {
            return logData?.docs;
        } else return [];
    }, [logData]);

    const cols = [
        {
            Header: 'Time',
            Cell: ({ row }) => {
                return (
                    <div>
                        {moment(row?.original?.timestamp).format(
                            'MMMM D, YYYY HH:mm:ss'
                        )}
                    </div>
                );
            },
            cellStyle: {
                width: '15%',
            },
        },
        {
            Header: 'Level',
            Cell: ({ row }) => {
                return <div>{row?.original?.level.toUpperCase()}</div>;
            },
            cellStyle: {
                width: '10%',
            },
        },
        {
            Header: 'Message',
            Cell: ({ row }) => {
                return <div>{row?.original?.message}</div>;
            },
            cellStyle: {
                width: '15%',
            },
        },
        {
            Header: 'Data',
            Cell: ({ row }) => {
                return (
                    <div>
                        <p>{JSON.stringify(row?.original?.metadata)}</p>
                        {row?.original?.metadata?.controller && (
                            <p>
                                Controller :{' '}
                                {row?.original?.metadata?.controller}
                            </p>
                        )}
                        {row?.original?.metadata?.env === 'development' ? (
                            <p>
                                At Development
                            </p>
                        ) : (
                            <p>
                                At Production
                            </p>
                        )}
                    </div>
                );
            },
            cellStyle: {
                width: '60%',
            },
        },
    ];

    const debounceSearch = useCallback(
        _.debounce(async(search)=>{
            fetchLogs(search)
        },300),
        []
    )

    return (
        <PageWithCard heading="System Logs">
            <TableWithHeadingAndGlobalSearch columns={cols} data={logMemo} searchFunction={debounceSearch}/>
            <PaginationClassic paginationDetails={logData} setPage={setPage} />
        </PageWithCard>
    );
};

export default Logs;
